<template>
  <div>
      <van-nav-bar
          fixed
          left-arrow
          title="单词列表"
          left-text=""
          right-text=""
          @click-left="onClickLeft"
          @click-right=""
      >
      </van-nav-bar>
      <div style="margin-top: 46px">
        <div v-if="typeShow === 'family' && $store.state.filterResultMeta.mode === 'derivative'" class="derivative-notice">
          词库中未收录“{{ $store.state.filterResultMeta.query }}”，仅查询到以下相关派生词或词形。
        </div>
        <van-cell-group
            v-model="loading"
            v-for="(word, index) in $store.state.filterResult"
            :key="index"
        >
          <van-cell  v-if="typeShow=='words'" :title="word.英文 + ' ' + word.中文"  :label="word.词性 + ' ' + word.备注 + ' '" style="font-size: 15px"
          >
            {{word.教材}}  {{word.模块}}
          </van-cell>

          <van-cell @click="popDialog3500(index)" v-if="typeShow=='3500'" :title="word.英文 + ' ' + word.词性" :label="word.简单中文" style="font-size: 15px"
          >
            <template #title>

              <van-row justify="space-between">

                  <van-tag plain :color="classObje(word.词性)"> {{ word.英文 }}</van-tag>
                  <span style="font-size: 10px">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ word.词性 }}</span>

              </van-row>

            </template>
          </van-cell>

          <van-cell @click="popDialogFamily(index)" v-else-if="typeShow=='family'" :label="word.简单中文" style="font-size: 15px">
            <template #title>
              <van-row justify="space-between">
                <van-tag plain :color="classObje(word.词性)">{{ word.英文 }}</van-tag>
                <span v-if="word.关系标签" class="relation-label">{{ word.关系标签 }}</span>
                <span style="font-size: 10px">{{ word.词性 }}</span>
              </van-row>
            </template>
            <template #default>
              <span class="family-unit">{{ word.单元 }}</span>
            </template>
          </van-cell>

          <van-cell @click="popDialogWords(index)" v-else-if="typeShow=='words'" :title="word.英文 + ' ' + word.中文 + ' / ' + word.词性"  :label="word.备注 + ' ' +' '" style="font-size: 15px"
          >
            {{word.教材}}  {{word.模块}}<br>

          </van-cell>
        </van-cell-group>
      </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Toast } from 'vant';
import { Dialog } from 'vant';
import { gaokaoDetail, joinDetails, textbookDetail } from '../utils/gaokao';

Vue.use(Toast);
export default {
  name: "wordsList",
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  data(){
    return {
      loading: '',
      transitionName: 'transitionLeft',
      typeShow: 'words',
      filterResult: [],
    }
  },
  methods: {
    onLoad() {
    },
    onClickLeft() {
      this.$router.go(-1)
      // this.$router.push({ name: 'filterWords', params: {}});
      this.$store.state.filterResult = [];
      this.$store.state.filterResultMeta = { mode: 'normal', query: '' };
    },
    // 显示3500单词
    popDialog3500(index){
      // console.log(this.$store.state.filterResult[index])
      const word = this.$store.state.filterResult[index];
      const gaokao = this.$store.state.gaokaoWords.find(item => item.英文 === word.英文);
      const textbooks = this.$store.state.newWords.filter(item => item.英文 === word.英文);
      Dialog.alert({
        title: this.$store.state.filterResult[index]['英文'],
        message: joinDetails([...textbooks.map(textbookDetail), gaokaoDetail(gaokao && gaokao.中文)]) || textbookDetail(word),
        theme: 'round-button',
        messageAlign: 'left',
        width:'95%'
      }).then(() => {
        // on close
      });
    },
    // 显示教材单词
    popDialogWords(index){
      Dialog.alert({
        title: this.$store.state.filterResult[index]['英文'],
        message: this.$store.state.filterResult[index]['教材'] + '：\n'
             + this.$store.state.filterResult[index]['词性'] + '\n' + this.$store.state.filterResult[index]['中文'],
        theme: 'round-button',
        messageAlign: 'left',
        width:'95%'
      }).then(() => {
        // on close
      });
    },
    popDialogFamily(index){
      const word = this.$store.state.filterResult[index];
      Dialog.alert({
        title: word.英文,
        message: `${word.关系标签 ? `${word.关系标签}\n-------------------------------\n` : ''}${word.弹窗中文 || word.中文 || '暂无释义'}`,
        theme: 'round-button',
        messageAlign: 'left',
        width:'95%'
      });
    },

  },
  watch: {
  },
  computed: {
    classObje() {
      return (attribute) => { // 使用JavaScript闭包，进行传值操作
        if(attribute.indexOf('.')==-1) attribute = attribute + '.'
        if(attribute.indexOf('/')!=-1 && attribute.indexOf('n.')!=-1)return'red'
        if(attribute.indexOf('/')!=-1 && attribute.indexOf('v.')!=-1)return'blue'
        if(attribute.indexOf('/')!=-1 && attribute.indexOf('adj.')!=-1)return'orange'
        function hasLetter(str) {
          for (let i in str) {
            let asc = str.charCodeAt(i);
            if ((asc >= 65 && asc <= 90 || asc >= 97 && asc <= 122)) {
              return true;
            }
          }
          return false;
        }
        if(!hasLetter(attribute)) {
          const lengthAttribute = attribute.length;
          if(lengthAttribute <= 7)return '#FF8C69'
          if(lengthAttribute > 7 && lengthAttribute <= 10)return '#FF7256'
          if(lengthAttribute > 10 && lengthAttribute <= 13)return '#FFE1FF'
          if(lengthAttribute > 14 && lengthAttribute <= 20)return '#00FFFF'
          if(lengthAttribute > 20)return 'Cornsilk'
        }
        const map = {
          'n.': '#FF00FF',
          'adj.': 'darkred',
          'v.': '#FFD700',
          'adv.': 'skyblue',
          'prep.': 'darkslategrey',
          'pron.': '#6f42c1',
          'art.': 'green'
        };
        return map[attribute] ? map[attribute] : '';
      }
    }
  },
  activated(){
  },
  mounted() {
    // console.log(this.$route.params.typeShow);
    this.typeShow = this.$route.params.typeShow;
    // this.simplifyTranslation();
  },
  created() {


  }
}
</script>

<style scoped>
.derivative-notice {
  margin: 10px 12px;
  padding: 10px 12px;
  border-radius: 8px;
  color: #8a5a00;
  background: #fff7df;
  font-size: 13px;
  line-height: 1.5;
}
.relation-label {
  margin-left: auto;
  margin-right: 8px;
  color: #c77900;
  font-size: 11px;
}
.family-unit {
  display: block;
  margin-top: 4px;
  color: #969799;
  font-size: 11px;
}
</style>
